<template>
  <div class="network-diagnostics">
    <h3>网络诊断信息</h3>
    <div class="diagnostic-item">
      <span class="label">当前访问地址:</span>
      <span class="value">{{ currentURL }}</span>
    </div>
    <div class="diagnostic-item">
      <span class="label">API基础地址:</span>
      <span class="value">{{ apiBaseURL }}</span>
    </div>
    <div class="diagnostic-item">
      <span class="label">设备类型:</span>
      <span class="value">{{ deviceType }}</span>
    </div>
    <div class="diagnostic-item">
      <span class="label">用户代理:</span>
      <span class="value small">{{ userAgent }}</span>
    </div>
    <div class="diagnostic-item">
      <span class="label">建议:</span>
      <span class="value suggestion">{{ suggestion }}</span>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { API_BASE_URL } from '@/config/env'

export default {
  name: 'NetworkDiagnostics',
  setup() {
    const currentURL = ref('')
    const apiBaseURL = ref('')
    const deviceType = ref('')
    const userAgent = ref('')
    const suggestion = ref('')

    onMounted(() => {
      currentURL.value = window.location.href
      userAgent.value = navigator.userAgent
      
      // 检测设备类型
      const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      deviceType.value = isMobile ? '移动设备' : '桌面设备'
      
      // 获取API地址
      const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
      // 使用统一的环境配置
      apiBaseURL.value = API_BASE_URL
      
      // 生成建议
      if (isMobile && isLocalhost) {
        suggestion.value = '移动设备无法访问localhost，请使用电脑的IP地址访问，例如：http://192.168.1.100:8080'
      } else if (isMobile) {
        suggestion.value = '移动设备访问正常，API地址已自动适配'
      } else {
        suggestion.value = '桌面设备访问正常'
      }
    })

    return {
      currentURL,
      apiBaseURL,
      deviceType,
      userAgent,
      suggestion
    }
  }
}
</script>

<style scoped>
.network-diagnostics {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  margin: 16px 0;
  font-size: 14px;
}

.diagnostic-item {
  display: flex;
  margin-bottom: 8px;
  align-items: flex-start;
}

.label {
  font-weight: 600;
  color: #1d1d1f;
  min-width: 120px;
  flex-shrink: 0;
}

.value {
  color: #666;
  word-break: break-all;
  flex: 1;
}

.value.small {
  font-size: 12px;
}

.value.suggestion {
  color: #007aff;
  font-weight: 500;
}
</style>